import { ElementRef, Injectable, SimpleChanges } from '@angular/core';
import { RendererOptions } from '@hi-level/2d-renderer';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class DrawingSessionService {
  zoomLevel: BehaviorSubject<number>;
  minZoom: BehaviorSubject<number>;
  onComponentDrag: Subject<any>;

  init(
    floorData: any,
    drawing: any,
    options: RendererOptions,
    rendererElement: ElementRef
  ): void {
    throw new Error('Cannot call init() - DrawingSessionService not provided!');
  }

  onChanges(changes: SimpleChanges): void {
    throw new Error(
      'Cannot call onChanges() - DrawingSessionService not provided!'
    );
  }

  onZoomChange(newZoomLevel: number): void {
    throw new Error(
      'Cannot call onZoomChange() - DrawingSessionService not provided!'
    );
  }

  addCutouts(cutouts: any[]): void {
    throw new Error(
      'Cannot call addCutouts() - DrawingSessionService not provided!'
    );
  }

  onComponentDragStop(component: any): void {
    throw new Error(
      'Cannot call onComponentDragStop() - DrawingSessionService not provided!'
    );
  }

  getImageUrl(): string {
    throw new Error(
      'Cannot call getImageUrl() - DrawingSessionService not provided!'
    );
  }

  setViewStyle(newStyle: string): void {
    throw new Error(
      'Cannot call newStyle() - DrawingSessionService not provided!'
    );
  }

  renderFloor(): void {
    throw new Error(
      'Cannot call renderFloor() - DrawingSessionService not provided!'
    );
  }

  addNewCutouts(formValue: any): any[] {
    throw new Error(
      'Cannot call addNewCutout() - DrawingSessionService not provided'
    );
  }

  resizeCutouts(formValue: any, cutout: any): any {
    throw new Error(
      'Cannot call resizeCutouts() - DrawingSessionService not provided'
    );
  }
}
